import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=66c04e60&"
import script from "./TopNav.vue?vue&type=script&lang=ts&"
export * from "./TopNav.vue?vue&type=script&lang=ts&"
import style0 from "./TopNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Search: require('/home/runner/work/did-homepage/did-homepage/src/components/Search.vue').default,WalletConnectButton: require('/home/runner/work/did-homepage/did-homepage/src/components/WalletConnectButton.vue').default})
